import React from 'react';
import { Card, CardContent, Divider, Grid, Typography } from '@material-ui/core';

import Button from '~/components/Button';

interface SummaryCardProps {
  association: string;
  customer: string;
  vehicle: string;
  service: string;
  contractor: string;
  paymentMethod: string;
  origin: string;
  destination: string;
  loading: boolean;
  onSubmit: () => void;
}

const ItemLabel = ({ label, value }: { label: string; value: string }) => (
  <Grid item xs={12} md={6}>
    <Typography variant='subtitle2' style={{ fontWeight: 600 }}>
      {label}
    </Typography>
    <Typography variant='body2'>{value || '-'}</Typography>
  </Grid>
);

export default function SummaryCard({
  association,
  customer,
  vehicle,
  service,
  contractor,
  paymentMethod,
  origin,
  destination,
  loading,
  onSubmit,
}: SummaryCardProps) {
  return (
    <Card>
      <CardContent>
        <Typography variant='h6' style={{ marginBottom: 12 }}>
          Resumo da oportunidade
        </Typography>

        <Grid container spacing={2}>
          <ItemLabel label='Empresa' value={association} />
          <ItemLabel label='Cliente' value={customer} />
          <ItemLabel label='Veiculo' value={vehicle} />
          <ItemLabel label='Servico' value={service} />
          <ItemLabel label='Prestador' value={contractor} />
          <ItemLabel label='Pagamento' value={paymentMethod} />
          <ItemLabel label='Origem' value={origin} />
          <ItemLabel label='Destino' value={destination} />
        </Grid>

        <Divider style={{ margin: '16px 0' }} />

        <Button label='Gerar Oportunidade' filled loading={loading} onClick={onSubmit} />
      </CardContent>
    </Card>
  );
}
